import { useEffect, useState } from 'react';

export const useSearchSuggestionsHeight = (element: HTMLElement | null, suggestions: unknown[]) => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setHeight(element?.getBoundingClientRect().height ?? 0);
  }, [suggestions, element]);

  return height;
};
